module.exports = __webpack_public_path__ + "static/img/special-day-mobile.9eaa158.svg";